// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__E2x5I","on-light":"TextLink_on-light__Z02fy","on-dark":"TextLink_on-dark__ULJfp","neutral":"TextLink_neutral__OZYBD","bold":"TextLink_bold__xoqXg"};